:host {
  @extend %component-host;
  @apply flex
    flex-auto
    overflow-hidden
    bg-transparent
    z-default;
}

.content {
  @apply m-0
    flex
    h-full
    w-full
    overflow-hidden;
  flex: 1 0 0;
}

.action-bar-container {
  @apply flex;
}

:host([detached]) {
  @apply shadow-0
  animate-in-up
  mx-2
  mt-2 mb-6 rounded
  border-0;
}

:host([position="end"]) {
  @apply self-end;
}

:host([position="start"]) {
  @apply self-start;
}

:host([height-scale="s"]) {
  block-size: theme("width[1/3]");
}

:host([height-scale="m"]) {
  block-size: 70%;
}

:host([height-scale="l"]) {
  @apply h-full;
}

:host([height-scale="l"][detached]) {
  block-size: calc(theme("height.full") - theme("spacing.8"));
}

::slotted(calcite-panel) {
  @apply h-full w-full;
}

::slotted(calcite-action-bar),
::slotted(calcite-action-bar[position="end"]) {
  border-inline-end: theme("borderWidth.DEFAULT") solid;
  @apply border-color-3;
}

@include base-component();
